import { ApiFlightType } from '@ve/types/api/ApiFlightType';
import { FlightType } from '@entities/tourProduct';

export default (flightType: ApiFlightType): FlightType => (flightType === 'regular' ? 2 : 1);